import React, { useState } from "react";
import "../Stylesheets/Header.css";
import { FaBars, FaTimes } from "react-icons/fa";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { path: "/", link: "Home" },
    // { path: "/curriculum", link: "Curriculum" },
    { path: "/program", link: "Benefits" },
    
    // { path: "/aboutus", link: "About" },
    { path: "/tech_stack", link: "Technologies" },
    { path: "/guaranteed-placement", link: "Job Guarantee" },
    { path: "/learning-path", link: "Roadmap" },
    { path: "/contact", link: "Contact Us" },

    // { path: "/contact", link: "Join Now" },
    // { path: "/quiz", link: "Quiz" },
  ];

  return (
    <header className="header">
      <div className="container mx-auto py-2">
      <nav className="d-flex justify-content-between  align-items-center p-1">
        {/* Logo */}
     
        <a className="logo" href="/">
          <img
            // src="https://d242nlqul83u9g.cloudfront.net/NB_Media/15.05.2025/web_size_2.png"
            src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img11545_IMG.png"
            alt="logo"
            
          />
        </a>
    

        {/* Desktop Menu */}
        <ul
          className={`nav-menu d-flex ${menuOpen ? "active" : ""} `}
          style={{ fontSize: "1rem" }}
        >
          {navItems.map((item, index) => (
            <li key={index} className="list-unstyled">
              <a
                className="nav-link text-light px-3"
                href={item.path}
                onClick={() => setMenuOpen(false)} 
              >
                {item.link}
              </a>
            </li>
          ))}
        </ul>
        
        {/* Hamburger Icon */}
        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? (
            <FaTimes size={24} color="#fff" />
          ) : (
            <FaBars size={24} color="#fff" />
          )}
        </div>
      </nav>
      </div>
    </header>
  );
};

export default Header;
